import React, {Component} from 'react';
import axios from 'axios';
import {getGetHeaders} from '../shared/functions';
import {setDefaultTableSort, filterCaseInsensitive} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ReactTable from 'react-table';
import {RESOURCES as locationsResources} from '../fuseLocationsResourceMap';
import '../shared/react-table.css';
import {tableStyles} from '../shared/styles-table';
import CircularProgress from 'material-ui/CircularProgress';

class LocationsByDistrictTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            districtId: (props.record && props.record.district_id) ? props.record.district_id : null,
            dataTable: [],
            originalData: [],
            isLoading: false,
            message: null
        };
    }

    componentWillMount() {
        if (this.state.districtId) {
            this.fetchData();
        }
    }

    /**
     * Get list of locations that belong to selected district id
     *
     */
    fetchData() {
        this.setState({
            isLoading: true
        })
        let params = {
            filter: {
                filter_by: 'filter_district',
                filter_district: this.state.districtId,
            }
        };
        let noneMessage;
        let resource = locationsResources.Locations.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            let list = [];
            if (result.error) {
                noneMessage = 'Sorry, there was an error retrieving locations for this district.';
            } else if (result.data && result.data.payload) {
                list = result.data.payload;
            } else if (result.data && result.data.length > 0) {
                list = result.data;
            }
            this.setState({
                dataTable: list,
                originalData: list,
                message: noneMessage,
                isLoading: false
            });
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
            } else {
            }
            noneMessage = 'Sorry, there was an error retrieving locations for this district.';
            this.setState({
                dataTable: [],
                districtId: null,
                originalData: [],
                message: noneMessage,
                isLoading: false
            });
        });
    }

    render() {
        const {
            originalData,
            message,
            isLoading,
        } = this.state;

        const defaultSort = setDefaultTableSort({field: 'id', order: 'ASC'});

        const tableColumns = [
            {
                Header: 'Location ID',
                accessor: 'id',
                headerStyle: tableStyles.left
            },
            {
                Header: 'Name',
                accessor: 'name',
                headerStyle: tableStyles.left
            },
            {
                Header: 'City',
                accessor: 'city',
                headerStyle: tableStyles.left
            },
            {
                Header: 'State',
                accessor: 'state',
                width: 90,
                headerStyle: tableStyles.left
            },
            {
                Header: 'DBA Name',
                accessor: 'dba.name',
                headerStyle: tableStyles.left
            },
            {
                Header: 'Active',
                accessor: 'active',
                Cell: row => (
                    <span>{row.original.active ? "YES" : "NO"}</span>
                ),
                filterable: false,
                width: 90,
                headerStyle: tableStyles.left
            },
        ];

        return (
            <div>
                {isLoading &&
                    <div className="loader-container">
                        <h4>Retrieving Locations...</h4>
                        <CircularProgress
                            size={24}
                            thickness={2}
                            className="loader"
                        />
                    </div>
                }

                {originalData.length > 0 &&
                    <div className="list-table-container no-padding">
                        <ReactTable
                            key="table-collections-list"
                            data={originalData}
                            columns={tableColumns}
                            defaultPageSize={20}
                            showPagination={true}
                            defaultSorted={defaultSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            ref={(r) => this.collectionsReactTable = r}
                            resizable={false}
                            minRows={1}
                        />
                    </div>
                }
                {message &&
                    <p>{message}</p>
                }
            </div>
        );
    }
}

export default LocationsByDistrictTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationsByDistrictTable.js